import type { IconSvgObject } from './types';

const ShoppingBasket02Icon: IconSvgObject = [
  ["path", { d: "M4.34085 16.8781L3.17786 9.93557C2.98869 8.8063 2.89411 8.24167 3.18537 7.87083C3.47662 7.5 4.01468 7.5 5.09079 7.5H18.9092C19.9853 7.5 20.5234 7.5 20.8146 7.87083C21.1059 8.24167 21.0113 8.8063 20.8221 9.93557L19.6591 16.8781C19.249 19.3264 19.044 20.5505 18.2319 21.2752C17.4199 22 16.2534 22 13.9204 22H10.0796C7.74664 22 6.58014 22 5.76809 21.2752C4.95603 20.5505 4.75097 19.3264 4.34085 16.8781Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 7.5V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V7.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.5 17.5H19.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default ShoppingBasket02Icon;
